import React from 'react';
import JwtClient from "./JwtClient";
import Form from "react-bootstrap/Form";
import {InputGroup} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Alert from "./Alert";

export default class IBCCustomsClearanceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alert: '',
            isSubmitting: false,
            selectedClearanceType: 'CFS type 86',
            validationEmails: 'vlad@veloxshipping.com',
            validationEmailsErr: '',
        }
    }

    render() {
        return (
            <div>
                <hr/>
                {this.state.alert && <Alert>{this.state.alert}</Alert>}
                <Form onSubmit={this.handleSubmit}>

                    {/*<Form.Group>*/}
                    {/*<InputGroup>*/}
                    {/*    <InputGroup.Prepend>*/}
                    {/*        <InputGroup.Text>Validation emails</InputGroup.Text>*/}
                    {/*    </InputGroup.Prepend>*/}
                    {/*    <Form.Control*/}
                    {/*        type="text"*/}
                    {/*        name="validationEmails"*/}
                    {/*        value={this.state.validationEmails}*/}
                    {/*        onChange={e => {*/}
                    {/*            this.setErrors({[e.target.name]: ''});*/}
                    {/*            this.setState({[e.target.name]: e.target.value});*/}
                    {/*        }}*/}
                    {/*        isInvalid={this.state.validationEmailsErr}*/}
                    {/*    />*/}
                    {/*    <Form.Control.Feedback type="invalid">*/}
                    {/*        {this.state.validationEmailsErr}*/}
                    {/*    </Form.Control.Feedback>*/}
                    {/*</InputGroup>*/}
                    {/*<Form.Text className="text-muted">*/}
                    {/*    Comma separated emails*/}
                    {/*</Form.Text>*/}
                    {/*</Form.Group>*/}

                    <Form.Group>
                        <Form.Check
                            type="radio"
                            name="clearanceType"
                            value="CFS type 86"
                            id="CFS type 86"
                            label="CFS type 86"
                            inline
                            checked={this.state.selectedClearanceType === 'CFS type 86'}
                            onChange={this.handleChangeClearanceType}
                        />
                        <Form.Check
                            type="radio"
                            name="clearanceType"
                            value="ECCF"
                            id="ECCF"
                            label="ECCF"
                            inline
                            checked={this.state.selectedClearanceType === 'ECCF'}
                            onChange={this.handleChangeClearanceType}
                            disabled
                        />
                        <Form.Check
                            type="radio"
                            name="clearanceType"
                            value="CFS"
                            id="CFS"
                            label="CFS"
                            inline
                            checked={this.state.selectedClearanceType === 'CFS'}
                            onChange={this.handleChangeClearanceType}
                        />
                        <Button type="submit" disabled={this.state.isSubmitting} className="btn-warning float-right">IBC
                            Manifest {this.state.selectedClearanceType}</Button>
                    </Form.Group>

                    {/*<Form.Group>*/}
                    {/*    <Button type="submit" disabled={this.state.isSubmitting} className="btn-success">IBC Manifest</Button>*/}
                    {/*</Form.Group>*/}
                </Form>
            </div>
        );
    }

    handleSubmit = e => {
        e.preventDefault();
        this.setState({isSubmitting: true});
        if (!this.state.validationEmails) {
            this.setErrors({validationEmails: 'Required'});
            return
        }
        JwtClient.post(`/api/v1/admin/manifests/${this.props.manifestId}/customs-clearance/ibc`, {
            clearance_type: this.state.selectedClearanceType,
            validation_emails: this.splitValidationEmails(this.state.validationEmails),
        })
            .then(response => {
                if (response.status === 200) {
                    this.props.setClearanceType(this.state.selectedClearanceType);
                }
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status === 401) {
                        this.setState({alert: 'Unauthorized'})
                    }
                    this.setState({alert: 'Error on IBC customs clearance, status: ' + error.response.status + ' Data: ' + JSON.stringify(error.response.data)});
                } else {
                    this.setState({alert: JSON.stringify(error)});
                }
            })
            .finally(() => {
                this.setState({isSubmitting: false});
            })
    };

    handleChangeClearanceType = e => {
        this.setState({selectedClearanceType: e.target.value});
    };

    setErrors = errors => {
        this.setState((prevState) => ({errors: {...prevState.errors, ...errors}}));
    };

    splitValidationEmails = (emails) => {
        let result = [];
        let e;
        for (e of emails.split(',')) {
            result.push(e.trim());
        }
        return result
    };
}